import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, Rocket } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export function VercelExportCard() {
  const { token } = useAuth();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/superadmin/vercel-export", { responseType: "blob", headers: { Authorization: `Bearer ${token}` } });
      const url = URL.createObjectURL(res.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: "alfaz-vercel.zip" });
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Zip Vercel dimuat turun");
    } catch (e) {
      const text = e?.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : errMsg(e);
      toast.error(text);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="bg-[#3B0A0A] text-white rounded-2xl p-6 space-y-3" data-testid="vercel-export-card">
      <h3 className="font-display font-bold flex items-center gap-2"><Rocket className="w-5 h-5 text-amber-400" />Eksport ke Vercel <span className="text-[10px] px-2 py-0.5 rounded-full bg-amber-400 text-[#3B0A0A] font-bold">SUPERADMIN</span></h3>
      <p className="text-sm text-white/75">Zip lengkap (frontend + API serverless) dengan sambungan MongoDB Atlas siap ditetapkan. Import terus ke Vercel.</p>
      <button onClick={download} disabled={busy} data-testid="vercel-export-download"
        className="px-5 h-11 rounded-xl bg-amber-400 text-[#3B0A0A] font-semibold flex items-center gap-2 hover:bg-amber-300 active:scale-95 transition-[background-color,transform] disabled:opacity-70">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Muat Turun Zip Vercel
      </button>
    </section>
  );
}
